<div class="adaa-auth-page" [dir]="languageService.direction()">
    <div class="adaa-auth-card">
        <div class="adaa-auth-form-panel">
            <div class="adaa-auth-inner">
                <img
                    class="adaa-auth-logo theme-light-only"
                    alt="ADAA"
                    ngSrc="assets/images/adaa_logo_login_light.png"
                    width="320"
                    height="180"
                    priority
                />
                <img
                    class="adaa-auth-logo theme-dark-only"
                    alt="ADAA"
                    ngSrc="assets/images/adaa_logo_login_dark.png"
                    width="320"
                    height="180"
                    priority
                />

                <ng-content />

                <div class="adaa-auth-lang">
                    <a role="button" (click)="languageService.switchLanguage()">
                        <i class="fa-solid fa-globe"></i>
                        <span>{{ "language.change_lang" | translate }}</span>
                    </a>
                </div>
            </div>
        </div>

        <div class="adaa-auth-flag">
            <img alt="UAE flag" src="assets/images/uae_flag.jpeg" />
        </div>
    </div>
</div>

<adaa-spinner></adaa-spinner>
